import styled from "styled-components";

export const TerminalMain = styled.main`
.border{
	border-bottom: 1px solid #b7c04b;
}

.trading__together{
	color: #fff;
	& a {
		margin-top: 1.875rem;
		width: 11.563rem;
	}
}
`